import React from 'react';
import PropTypes from 'prop-types';

import { ButtonV2 } from '@zola/zola-ui';
import { trackUploadSpreadsheetStepCompleted } from '../../../../../util/trackingHelper';

import './MappingIntro.styles.less';

import featureFlag from '../../../../../util/featureFlags';

const isSpreadsheetUploadTracking = featureFlag.get('isSpreadsheetUploadTracking');

const MappingIntro = ({ onMappingStart, flowRunId }) => (
  <div className="add-guest-group-modal mapping-intro__content">
    <h4 className="intro__title">Almost there!</h4>
    <p className="intro__text">
      Drag and drop to match details from our list with yours, so we can add that info from your
      spreadsheet to your guest list.
    </p>
    <video muted playsInline autoPlay preload="auto" loop className="intro__video">
      <source
        src="https://zola-web-assets.s3.us-east-1.amazonaws.com/web-wedding/guest-list-animations/Detail-Matching.mp4"
        type="video/mp4"
      />
      Sorry, your browser doesn&apos;t support embedded videos.
    </video>
    <ButtonV2
      onClick={() => {
        onMappingStart();
        if (isSpreadsheetUploadTracking) {
          trackUploadSpreadsheetStepCompleted(
            {
              step_name: 'Got It',
              step_number: 2,
              step_value_type: null,
              step_value: null,
            },
            flowRunId
          );
        }
      }}
      className="intro__btn"
    >
      Got it
    </ButtonV2>
  </div>
);

MappingIntro.propTypes = {
  onMappingStart: PropTypes.func,
  flowRunId: PropTypes.string,
};

export default MappingIntro;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/content/MappingIntro.jsx